import { isBrowser, isTablet } from 'react-device-detect'
import { showToast } from '../common/utils'
import { gaEvent } from '../common/services/analytics'
import { postJSON } from '../common/services/api'

export function resendInvite(id, cb) {
  return () => {
    const isDesktop = isBrowser || isTablet
    postJSON({ url: `users/${id}/resend-invite` })
      .then(() => {
        gaEvent({
          category: 'Carers',
          action: `Resend invite`,
        })

        if (cb) cb()
        showToast({
          type: 'success',
          title: isDesktop
            ? `Invite sent! An email should arrive in their inbox soon.`
            : 'Invite sent!',
        })
      })
      .catch(() => {
        showToast({
          type: 'error',
          title: isDesktop
            ? "We're unable to process your request at this time. Please contact support."
            : 'Please contact support.',
        })
      })
  }
}
